import { parseFoldLayout } from '@messenger/utils'
import type { FoldLayoutSource } from '@messenger/utils'

/**
 * Whether a layout is a trifold, valid or not. Each of a trifold's pages takes
 * its own folds, which only a page drawn on its own carries, so the preview,
 * the proof and the final print draw a trifold page by page, each page once.
 */
export const isTrifoldLayout = (
  layout: FoldLayoutSource | null | undefined,
): boolean => parseFoldLayout(layout).kind !== 'not-trifold'

/**
 * Whether the preview, the proof and the final print draw a page set's first
 * two pages as one legacy combined page, which a page set asks for with
 * `pageProperties.concatenatedPages`. A trifold never does. Without a layout
 * the page set's own request stands; the preview has none until its layout
 * loads, or when that load fails.
 */
export const combinesPages = (
  concatenatedPages: number | null | undefined,
  layout: FoldLayoutSource | null | undefined,
): boolean => (concatenatedPages ?? 0) > 0 && !isTrifoldLayout(layout)
